import { render, staticRenderFns } from "./ClassTimeTableForHD.vue?vue&type=template&id=212dd09e&scoped=true"
import script from "./ClassTimeTableForHD.vue?vue&type=script&lang=js"
export * from "./ClassTimeTableForHD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212dd09e",
  null
  
)

export default component.exports